import i18n from '../../../base-dictionary';
import { Tab } from '../process-analysis-v2.type';

const tabs = [
  { id: Tab.Portfolios, label: i18n.t('process_analysis.tabs.portfolios'), icon: 'cases' },
  { id: Tab.Projects, label: i18n.t('process_analysis.tabs.projects'), icon: 'inventory_2' },
  { id: Tab.Boards, label: i18n.t('process_analysis.tabs.boards'), icon: 'space_dashboard' },
];

export { tabs };
